
import './PTrackContent.scss';
export default function PTrackContent(props: any) {
    return (
        <div className="ptrack-content " data-ui-tracking-context="%7B%22appView%22:%22episodesSelector%22%7D" data-tracking-uuid="31078b13-889d-4aa9-a85e-6f88abf57402">{props.children}</div>
    );
}